

const bread = {
    namespaced: true,
    state: {
        listData: []
    },
    mutations: {
        uploadBreadcrumb: (state, vm) => {
            if (state.listData.some(v => v.name === vm.name)) {
                state.listData.forEach((v, i) => {
                    if (v.name === vm.name) {
                        v.path = vm.path;
                    }
                });
                return
            }
            state.listData.push(vm)
            state.listData.forEach((i, index) => {
                if (i.name == null) state.listData.splice(index, 1)
            })
        },
        clearBreadList: (state, vm) => {
            state.listData = []
        },
        delVisitedViews: (state, view: any) => {
            if (state.listData.length > 1) {
                state.listData.forEach((v, i) => {
                    if (v.path === view.path) {
                        state.listData.splice(i, 1);
                    }
                });
            } else {
                state.listData.length = 0
            }
        },
    },
    actions: {
        async addBreadcrumb({ commit }, payload: any) {

            commit('uploadBreadcrumb', payload)
        },
        async clearBreadList({ commit }, payload: any) {

            commit('clearBreadList', payload)
        },
        delVisitedViews({ state, dispatch, commit, getters, rootGetters }, view: any) {
            return new Promise<any[]>(resolve => {
                commit('delVisitedViews', view)
                resolve(state.listData)
            })
        },
    }
};

export default bread;
